export default __webpack_public_path__ + "static/media/listoVideoAtencion.cda547a6.svg";